import Itineraries from './Itineraries'

export default Itineraries
